// ============================================================================
// VOUCHER NUMBER SERVICE (ADR-0030) — non-consuming tentative preview.
// ============================================================================

import { get } from '../client/axiosClient';
import { voucherNumberEndpoints } from '../endpoints/commercial.endpoints';
import { buildEndpointWithQuery } from '../endpoints/base.endpoints';
import type { ApiResponse, ID, VoucherNumberPreviewDto } from '../types';

class VoucherNumberService {
  /** Tentative next number for a voucher type (AUTO) — NOT final; allocated only on Save. */
  async getPreview(voucherTypeId: ID, date?: string): Promise<VoucherNumberPreviewDto> {
    const url = buildEndpointWithQuery(voucherNumberEndpoints.preview(), { voucherTypeId, ...(date ? { date } : {}) });
    const response = await get<ApiResponse<VoucherNumberPreviewDto>>(url);
    return response.data.data;
  }
}

export const voucherNumberService = new VoucherNumberService();
export default voucherNumberService;
